/**
 * AI模型配置
 * 仅用于前端模型列表展示，API密钥由后端管理
 */

// 文本模型配置 - 指定显示的模型列表
// 规则：每个系列只保留阿里云百炼（DashScope 兼容模式）上可用的最新文本模型。
// 注意：模型名必须与后端 OPENAI_BASE_URL 渠道实际可用模型一致，否则报 404 Model not exist。
// 已实测确认（2026-10）：以下 4 个均返回 200。
//   - MiniMax/MiniMax-M3 带厂商前缀的写法在该兼容端点返回 400，仅 MiniMax-M2.5 可用
//   - glm-5.3-prime 为 5.3 的增强变体，如需可在下方追加
export const TEXT_MODELS_CONFIG = [
  { id: 'qwen3.8-max', name: 'Qwen3.8 Max', company: '阿里云' },
  { id: 'MiniMax-M2.5', name: 'MiniMax M2.5', company: 'MiniMax' },
  { id: 'kimi-k3', name: 'Kimi K3', company: '月之暗面' },
  { id: 'glm-5.3', name: 'GLM-5.3', company: '智谱AI' },
];

// 视觉模型配置 - 指定显示的视觉模型列表（同样须与后端渠道一致）
// 注意：qwen-vl-plus / qwen-vl-max / glm-4v / MiniMax-VL / kimi-vl / deepseek-vl
// 已在该 DashScope 渠道不可用，当前仅 qwen3-vl-plus 可用。
export const VISION_MODELS_CONFIG = [
  { id: 'qwen3-vl-plus', name: 'Qwen3-VL Plus', company: '阿里云' },
];

// 获取模型显示名称
export const getModelDisplayName = (modelId: string): string => {
  const allModels = [...TEXT_MODELS_CONFIG, ...VISION_MODELS_CONFIG];
  const model = allModels.find(m => m.id === modelId);
  if (model) {
    return `${model.name} (${model.company})`;
  }
  return modelId;
};

// 直接返回配置中的文本模型ID列表（不依赖后端返回，确保精确匹配）
export const filterModels = (_models?: string[]): string[] => {
  return TEXT_MODELS_CONFIG.map(m => m.id);
};

// 直接返回配置中的视觉模型ID列表（不依赖后端返回，确保精确匹配）
export const filterVisionModels = (_models?: string[]): string[] => {
  return VISION_MODELS_CONFIG.map(m => m.id);
};
